// As this component is only styles and no functionality,
// there's not much point in test coverage here
/* istanbul ignore file */
import { corners, media, typography } from "../../styles";
import { applyOpacity } from "../../styles/utils";
import styled from "styled-components";
export const Link = styled.a`
  ${typography.body}
  color: ${({
  theme
}) => theme.colours.dark};
  text-decoration: none;
  white-space: nowrap;
  border-bottom: 1px solid ${({
  theme
}) => theme.colours.dark};

  &:focus {
    border-bottom: 1px solid
      ${({
  theme
}) => applyOpacity(theme.colours.dark, 0)};
    ${corners.s}
  }

  @media ${media.hoverable} {
    &:hover {
      cursor: pointer;
      background-color: ${({
  theme
}) => applyOpacity(theme.colours.dark, 0.05)};
      border-bottom: 1px solid
        ${({
  theme
}) => applyOpacity(theme.colours.dark, 0)};
      ${corners.s}
    }
  }

  &:focus {
    outline: 1px solid ${({
  theme
}) => theme.colours.dark};
  }
`;
export default Link;